export const matchAlternateTexts = (text: string) => {
  const alternateTexts = [
    {
      key: 'fort',
      values: ['ft']
    },
    {
      key: 'mount',
      values: ['mt']
    },
    {
      key: 'saint',
      values: ['st', 'ste']
    }
  ];
  const match = alternateTexts.find(({ values }) => {
    const regex = new RegExp(`\\b(${values.join('|')})\\b`, 'i');
    return regex.test(text);
  });
  if (match) {
    return text.replace(new RegExp(`\\b(${match.values.join('|')})\\b`, 'i'), match.key);
  }
  return null;
};
